import SmallDetails from "components/SmallDetails/SmallDetails";
import React from "react";

interface Props {
  advice: server.dto.ReverseChangeAdvices
}

export const ReverseChargeAdvice = (props: Props) => {
  const adviceObj = serverReference.reverseChargeAdvices.find(e => e.value === props.advice);


  return <SmallDetails
    label={adviceObj?.label ?? RESX.GeneralLabels.Unknown}
    subLabel={adviceObj?.reason}
  />
}
